import React from 'react';
import styles from './TaskHeader.module.scss';

export const TaskHeader = ({
  title,
  hitTypeLabel,
  timestampLabel,
}: {
  title: string;
  hitTypeLabel?: string;
  timestampLabel?: string;
}) => {
  return (
    <div className={styles.HeaderContainer}>
      <div className={styles.TitleGroup}>
        <div className={styles.Title}>{title}</div>
        {hitTypeLabel && (
          <div className={styles.HitTypeBadge}>{hitTypeLabel}</div>
        )}
      </div>
      <div className={styles.Timestamp}>{timestampLabel}</div>
    </div>
  );
};
